/* unplugin-vue-components disabled */import script from "./TreeItem.vue?vue&type=script&setup=true&name=TreeItem&lang=js"
export * from "./TreeItem.vue?vue&type=script&setup=true&name=TreeItem&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=125e0d3a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125e0d3a"]])

export default __exports__